import { render, staticRenderFns } from "./SectionReason.vue?vue&type=template&id=6e4aa7b8&scoped=true&"
import script from "./SectionReason.vue?vue&type=script&lang=js&"
export * from "./SectionReason.vue?vue&type=script&lang=js&"
import style0 from "./SectionReason.vue?vue&type=style&index=0&id=6e4aa7b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4aa7b8",
  null
  
)

export default component.exports